import React from 'react';
import { CardActions } from 'material-ui/Card';
import { ListButton, ShowButton, DeleteButton, RefreshButton } from 'admin-on-rest';

import { history } from '../App'
import FlatButton from 'material-ui/FlatButton'
import ActionList from 'material-ui/svg-icons/action/list'

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const EditActions = ({ basePath, record, data, hasDelete, hasShow, hasList }) => (
    <CardActions style={cardActionStyle}>
        {hasShow && <ShowButton basePath={basePath} record={data} />}
		<FlatButton
	        primary
	        label="List"
	        icon={<ActionList />}
	        style={{ overflow: 'inherit' }}
			onClick={ e => history.goBack() }
	    />
        {(data && data.fields.status === 'new' && ! data.fields.is_released) && <DeleteButton basePath={basePath} record={data} />}
        <RefreshButton />
    </CardActions>
);

export default EditActions;



// WEBPACK FOOTER //
// ./src/CollectorAccount/EditActions.js